import { INBOX_TYPES, isInboxDeleteRequested } from 'dashboard/helper/inbox';

// Options of the "Respond from email" select: each email inbox's own address, followed by
// its aliases. The value is "<channelId>" or "<channelId>:<aliasId>".
// An inbox marked for deletion is left out, unless it is the one already picked
// (savedChannelId), so the select still shows the saved value.
export const respondFromOptions = (inboxes, savedChannelId = null) =>
  inboxes
    .filter(inbox => inbox.channel_type === INBOX_TYPES.EMAIL)
    .filter(
      inbox =>
        !isInboxDeleteRequested(inbox) ||
        (savedChannelId && inbox.channel_id === Number(savedChannelId))
    )
    .flatMap(inbox => {
      const name = inbox.internal_name || inbox.name;
      return [
        { value: String(inbox.channel_id), label: `${name} (${inbox.email})` },
        ...(inbox.email_aliases || []).map(emailAlias => ({
          value: `${inbox.channel_id}:${emailAlias.id}`,
          label: `${name} (${emailAlias.email})`,
        })),
      ];
    });

export const respondFromValue = (channelId, aliasId) => {
  if (!channelId) return '';
  return aliasId ? `${channelId}:${aliasId}` : String(channelId);
};

export const respondFromParams = value => {
  const [channelId, aliasId] = (value || '').split(':');
  return {
    respond_from_channel_id: channelId ? Number(channelId) : null,
    respond_from_alias_id: aliasId ? Number(aliasId) : null,
  };
};
